/** Xarita plitkalari (Esri qorong'i xaritasi, API key talab qilinmaydi).
 *  Buzilsa yoki key olinsa, shu yerda almashtiriladi. */
export const MAP_TILE_URL =
  'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}';

export const MAP_LABELS_URL =
  'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}';

export const MAP_ATTRIBUTION = 'Tiles &copy; Esri';
